import { ChartErrorIcon } from "./ChartErrorIcon";

type StatsCardProps = {
  header: string;
  number: string | number;
  descriptor: string;
  helperText?: string;
  className?: string;
  hasError?: boolean;
  isLoading?: boolean;
};

export function StatsCard({
  header,
  number,
  descriptor,
  helperText,
  className,
  hasError = false,
  isLoading = false,
}: StatsCardProps) {
  return (
    <div className={className}>
      <div className="flex items-center gap-sm">
        <h3 className="text-lg font-semibold text-primary">{header}</h3>
        <ChartErrorIcon show={hasError} />
      </div>
      {isLoading ? (
        <>
          <div className="flex items-baseline">
            <div className="h-12 w-32 animate-pulse rounded bg-secondary" />
          </div>
          <div className="h-6 w-48 animate-pulse rounded bg-secondary" />
        </>
      ) : (
        <div className="flex flex-col gap-xl">
          <div className="flex flex-wrap items-baseline">
            <span className="font-mono text-display-lg font-semibold text-primary [@media(min-height:60rem)]:text-display-xl [@media(min-height:90rem)]:text-[6vh] [@media(min-height:90rem)]:leading-[6.5vh]">
              {number}
            </span>
            <span className="ml-md text-sm text-primary [@media(min-height:90rem)]:text-[1vh]">
              {descriptor}
            </span>
          </div>
          {helperText && (
            <p className="font-body text-md text-tertiary [@media(min-height:90rem)]:text-[1vh] [@media(min-height:90rem)]:leading-[1.5vh]">
              {helperText}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
